import React, { FC } from 'react'
import { Stack } from 'components/Stack'
import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Table, TableHead, TableRow, TableHeadCell, TableBody, TableCell } from 'components/Table'
import { Flex } from 'components/Flex'
import { Icon } from 'components/Icon'
import { Badge } from 'components/Badge'
import { InvoiceStatus } from 'models/invoice'
import { useFetchInvoices } from 'services/organization'
import { Spinner } from 'components/Spinner'
import { formatPrice } from 'utils/currency'
import { DateUtils } from 'utils/date'

export const Invoices: FC = (_props) => {
  const { t } = useTranslation()

  const { status, invoices } = useFetchInvoices()

  const getBadge = (status: InvoiceStatus) => {
    switch (status) {
      case InvoiceStatus.Sent:
        return <Badge tone="caution">{t('invoices.status.sent')}</Badge>

      case InvoiceStatus.Paid:
        return <Badge tone="positive">{t('invoices.status.paid')}</Badge>

      case InvoiceStatus.Cancelled:
        return <Badge tone="critical">{t('invoices.status.cancelled')}</Badge>
    }
  }

  return (
    <div>
      <Stack space="xlarge">
        <Card>
          <Stack space="xlarge">
            <div>
              <Heading>{t('invoices.title')}</Heading>
              <Text>{t('invoices.description')}</Text>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadCell>
                    <Text weight="strong">{t('invoices.table.invoice_number')}</Text>
                  </TableHeadCell>
                  <TableHeadCell>
                    <Text weight="strong">{t('invoices.table.invoice_date')}</Text>
                  </TableHeadCell>
                  <TableHeadCell>
                    <Text weight="strong">{t('invoices.table.amount')}</Text>
                  </TableHeadCell>
                  <TableHeadCell>
                    <Text weight="strong">{t('invoices.table.status')}</Text>
                  </TableHeadCell>
                  <TableHeadCell></TableHeadCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {invoices &&
                  invoices.map((invoice) => (
                    <TableRow key={invoice.number}>
                      <TableCell>
                        <Text weight="strong">{invoice.number}</Text>
                      </TableCell>
                      <TableCell>
                        <Text weight="strong">{DateUtils.short(invoice.date)}</Text>
                      </TableCell>
                      <TableCell>
                        <Text weight="strong">{formatPrice(invoice.amount)}</Text>
                      </TableCell>
                      <TableCell>
                        <Text weight="strong">{getBadge(invoice.status)}</Text>
                      </TableCell>
                      <TableCell>
                        {invoice.status !== InvoiceStatus.Cancelled && (
                          <a download aria-label={t('common.download')} href={invoice.url}>
                            <Icon name="download-line"></Icon>
                          </a>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {status === 'loading' && (
              <Flex justify="center" align="center">
                <Spinner />
              </Flex>
            )}
          </Stack>
        </Card>
      </Stack>
    </div>
  )
}

Invoices.displayName = 'Invoices'
